// @noflow
export const forBeekeeper = ({ id, name, items }) => {
    const consumers = items.reduce((p, { id: itemId, include }) => (include ? [...p, itemId] : p), []);
    return { id, name, consumers };
};



// WEBPACK FOOTER //
// ./src/core/state/groups/utils.js